import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as html2canvas from 'html2canvas';
import * as jsPDF from 'jspdf';

@Injectable({
  providedIn: 'root',
})
export class PdfExportService {
  readonly #http = inject(HttpClient);

  generatePdf<T extends Record<string, any>>(
    data: T,
    templateName: string,
    suggestedName: string,
    baseContainerStyles: any = null
  ) {
    return new Promise((resolve, _reject) => {
      // Load the template from the assets folder
      this.#http
        .get(`assets/templates/${templateName}`, { responseType: 'text' })
        .subscribe(template => {
          // Replace placeholders in the template with corresponding values
          const filledTemplate = this.fillTemplateWithData(template, data);

          // Create a hidden div to hold the filled template
          const container = document.createElement('div');
          container.innerHTML = filledTemplate;
          document.body.appendChild(container);

          if (baseContainerStyles) {
            Object.keys(baseContainerStyles).forEach((key: string) => {
              (container.style as any)[key] = baseContainerStyles[key];
            });
          }

          // Generate PDF from the container
          html2canvas.default(container).then(canvas => {
            const imgData = canvas.toDataURL('image/png');
            const pdf = new jsPDF.jsPDF('p', 'px', 'a4');
            const imgProps = pdf.getImageProperties(imgData);
            const pdfWidth = pdf.internal.pageSize.getWidth();
            const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
            pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);

            resolve(null);
            pdf.save(`${suggestedName || 'exported'}.pdf`);

            // Remove the temporary container
            document.body.removeChild(container);
          });
        });
    });
  }

  private fillTemplateWithData<T extends Record<string, any>>(
    template: string,
    data: T
  ): string {
    // Replace placeholders in the template with data values
    Object.keys(data).forEach(key => {
      template = template.replaceAll(`{{ ${key} }}`, data[key]);
    });

    return template;
  }
}
